// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dataCheck_wrapper__3iwSS","tableWrapper":"dataCheck_tableWrapper__lpgF6"};